import one from './1.png'
import two from './2.jpeg'
import three from './3.png'
import four from './4.jpeg'
import five from './5.jpeg'


let new_collections = [
        {id:10,
    name:"Zip-neck T-shirt",
    image:one,
    new_price:1699,
    old_price:1850,
    color:"Green and White",
  },
 
  {id:20,
    name:"Premium Striped Textured Shirt",
    image:two,
    new_price:1699,
    old_price:1850,
    color:"White",
  },

  
  {id:30,
    name:"Premium Striped Textured Shirt",
    image:three,
    new_price:2390,
    old_price:2800,
    color:"White",
  },

   {id:40,
    name:"Premium Linen Blend(Cotton Linen shirt)",
    image:four,
    new_price:2390,
    old_price:2800,
    color:"White",
  },

   {id:50,
    name:"Premium remium Linen Blend(Cotton Linen shirt)",
    image:five,
    new_price:2390,
    old_price:2800,
    color:"White",
  },

];

export default new_collections;
